let fallbackSequence = 0

function randomBytes(): Uint8Array {
  const bytes = new Uint8Array(16)
  const cryptoProvider = globalThis.crypto

  if (typeof cryptoProvider?.getRandomValues === 'function') {
    try {
      return cryptoProvider.getRandomValues(bytes)
    } catch {
      // Continue with the non-cryptographic fallback for restricted runtimes.
    }
  }

  const timestamp = Date.now()
  fallbackSequence = (fallbackSequence + 1) >>> 0
  for (let index = 0; index < bytes.length; index += 1) {
    const timestampByte = Math.floor(timestamp / (2 ** ((index % 6) * 8))) & 0xff
    const sequenceByte = (fallbackSequence >>> ((index % 4) * 8)) & 0xff
    bytes[index] = Math.floor(Math.random() * 256) ^ timestampByte ^ sequenceByte
  }
  return bytes
}

export function createUuid(): string {
  const cryptoProvider = globalThis.crypto
  if (typeof cryptoProvider?.randomUUID === 'function') {
    try {
      return cryptoProvider.randomUUID()
    } catch {
      // Some runtimes expose randomUUID but reject it outside a secure context.
    }
  }

  const bytes = randomBytes()
  bytes[6] = (bytes[6] & 0x0f) | 0x40
  bytes[8] = (bytes[8] & 0x3f) | 0x80
  const hex = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}

export function createCorrelationId(): string {
  return createUuid().replaceAll('-', '')
}
